import * as React from 'react';
import * as Common from '_common';
import { useHouseWidgets } from './components/house/HouseComponents';
export const frames = [
    {
        id: 'default',
        title: { en: 'Default Frame', cs: 'Výchozí rám' },
        component: { type: 'Widgets_TimeSmall', properties: {} },
    },
    {
        id: 'monitoring',
        title: { en: 'Monitoring', cs: 'Monitoring' },
        component: { type: 'Widgets_MonitoringFull', properties: {} },
    },
    {
        id: 'weather',
        title: { en: 'Weather', cs: 'Počasí' },
        component: { type: 'Widgets_WeatherFull', properties: {} },
    },
    {
        id: 'time',
        title: { en: 'Time', cs: 'Čas' },
        component: { type: 'Widgets_TimeFrame', properties: {} },
    },
];
export function useWidgetRegister() {
    const houseWidgets = useHouseWidgets();
    return React.useMemo(() => [...commonWidgets, ...houseWidgets], [houseWidgets]);
}
const commonWidgets = [
    {
        id: 'time',
        title: { en: 'Time', cs: 'Čas' },
        components: {
            [Common.WidgetSize.Button]: { type: 'Widgets_TimeSmall' },
            [Common.WidgetSize.Frame]: { type: 'Widgets_TimeFrame' },
            [Common.WidgetSize.FullScreen]: { type: 'Widgets_TimeFull' },
        },
    },
    {
        id: 'weather',
        title: { en: 'Weather', cs: 'Počasí' },
        components: {
            [Common.WidgetSize.Frame]: { type: 'Widgets_WeatherFull' },
        },
    },
];
